import { createFileRoute } from "@tanstack/react-router";
import { site, pageUrl } from "@/data/site";
import { Breadcrumbs, PageHeader, Section } from "@/components/site/section";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms | Custom Orders & Payment | Paul's Pens n Things" },
      {
        name: "description",
        content:
          "How custom orders are quoted, confirmed, invoiced through PayPal, made and shipped, plus what happens if something is not right.",
      },
      { property: "og:title", content: "Terms | Paul's Pens n Things" },
      { property: "og:description", content: "The basics of ordering handcrafted, made-to-order work." },
      { property: "og:url", content: pageUrl("/terms") },
    ],
    links: [{ rel: "canonical", href: pageUrl("/terms") }],
  }),
  component: Terms,
});

function Terms() {
  return (
    <>
      <Breadcrumbs trail={[{ label: "Home", to: "/" }, { label: "Terms" }]} />
      <PageHeader eyebrow="Legal" title="Terms of Sale" lede="Everything here is made to order by hand, so the terms are written for that." />
      <Section className="pt-0">
        <div className="shell max-w-prose space-y-6 text-base leading-relaxed text-ink/85">
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Quotes and confirmation</h2>
          <p>
            Sending a request does not place an order. Paul reviews it, confirms what is achievable, and gives you a
            price. Work begins only once you agree.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Payment</h2>
          <p>
            Payment is made through a PayPal invoice sent by Paul. No payment is taken before the design and price are
            agreed.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Handmade variation</h2>
          <p>
            Wood, burl and resin vary naturally. Your piece will match the agreed design and materials, but grain,
            figure and colour will not be identical to any photograph.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Personalization</h2>
          <p>
            Engraved names, dates and wording are produced exactly as you supply them, so please check spelling
            carefully. Personalized pieces cannot be resold and cannot be returned for a change of mind.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Artwork and logos</h2>
          <p>
            You must own, or have permission to use, any logo or artwork you ask Paul to carve or engrave.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">Timing and shipping</h2>
          <p>
            Turnaround and shipping arrangements are confirmed with you for each project before you commit. Paul will
            tell you honestly if a deadline is not achievable.
          </p>
          <h2 className="font-[family-name:var(--font-display)] text-2xl text-ink">If something is not right</h2>
          <p>
            Contact Paul at{" "}
            <a href={`mailto:${site.email}`} className="underline underline-offset-4">
              {site.email}
            </a>{" "}
            or {site.phoneDisplay}. Faults in workmanship are put right.
          </p>
        </div>
      </Section>
    </>
  );
}
